// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB0PSIxNTk5MDE0Mjk2NTEwIiBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjE3Nzk4IiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0Ij48ZGVmcz48c3R5bGUgdHlwZT0idGV4dC9jc3MiPjwvc3R5bGU+PC9kZWZzPjxwYXRoIGQ9Ik05MzQuNCA0NzguNzJINzM3LjI4Yy0xNS44NzItMTEwLjA4LTExMS4xMDQtMTk0LjU2LTIyNS4yOC0xOTQuNTZTMzAyLjU5MiAzNjguNjQgMjg2LjcyIDQ3OC43Mkg4OS42djY2LjU2SDI4Ni43MmMxNS44NzIgMTEwLjA4IDExMS4xMDQgMTk0LjU2IDIyNS4yOCAxOTQuNTZzMjA5LjQwOC04NC40OCAyMjUuMjgtMTk0LjU2aDE5Ny4xMnYtNjYuNTZ6IiBmaWxsPSIjNzA3MDcwIiBwLWlkPSIxNzc5OSI+PC9wYXRoPjwvc3ZnPg==", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.leaflet-legend {
  background-color: white;
}

.leaflet-legend-title {
  margin: 3px;
  padding-bottom: 5px;
}

.leaflet-legend-column {
  float: left;
  margin-left: 10px;
}

.leaflet-legend-item {
  display: table;
  margin: 2px 0;
}

.leaflet-legend-item span {
  vertical-align: middle;
  display: table-cell;
  word-break: keep-all;
  white-space: nowrap;
  background-color: transparent;
  text-align: left;
}

.leaflet-legend-item-clickable {
  cursor: pointer;
}

.leaflet-legend-item-inactive span {
  color: #cccccc;
}

.leaflet-legend-item-inactive i img,
.leaflet-legend-item-inactive i canvas {
  opacity: 0.3;
  /*
    color: #000000;
    -webkit-filter: grayscale(100%);
    -moz-filter: grayscale(100%);
    -ms-filter: grayscale(100%);
    -o-filter: grayscale(100%);
    filter: grayscale(100%);
    filter: gray;
    */
}

.leaflet-legend-item i {
  display: inline-block;
  padding: 0px 3px 0px 4px;
  position: relative;
  vertical-align: middle;
}

.leaflet-legend-toggle {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: 50% 50%;
  box-shadow: none;
  border-radius: 4px;
}

.leaflet-legend-contents {
  display: none;
}

.leaflet-legend-expanded .leaflet-legend-contents {
  display: block;
  padding: 6px 15px 6px 6px;
}

.leaflet-legend-contents img {
  position: absolute;
}

.leaflet-legend-contents:after {
  content: "";
  display: block;
  clear: both;
}
`, "",{"version":3,"sources":["webpack://./src/css/leaftlet.legend.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,YAAY;EACZ;;;;;;;;KAQG;AACL;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,yDAA22B;EAC32B,4BAA4B;EAC5B,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;AACb","sourcesContent":[".leaflet-legend {\n  background-color: white;\n}\n\n.leaflet-legend-title {\n  margin: 3px;\n  padding-bottom: 5px;\n}\n\n.leaflet-legend-column {\n  float: left;\n  margin-left: 10px;\n}\n\n.leaflet-legend-item {\n  display: table;\n  margin: 2px 0;\n}\n\n.leaflet-legend-item span {\n  vertical-align: middle;\n  display: table-cell;\n  word-break: keep-all;\n  white-space: nowrap;\n  background-color: transparent;\n  text-align: left;\n}\n\n.leaflet-legend-item-clickable {\n  cursor: pointer;\n}\n\n.leaflet-legend-item-inactive span {\n  color: #cccccc;\n}\n\n.leaflet-legend-item-inactive i img,\n.leaflet-legend-item-inactive i canvas {\n  opacity: 0.3;\n  /*\n    color: #000000;\n    -webkit-filter: grayscale(100%);\n    -moz-filter: grayscale(100%);\n    -ms-filter: grayscale(100%);\n    -o-filter: grayscale(100%);\n    filter: grayscale(100%);\n    filter: gray;\n    */\n}\n\n.leaflet-legend-item i {\n  display: inline-block;\n  padding: 0px 3px 0px 4px;\n  position: relative;\n  vertical-align: middle;\n}\n\n.leaflet-legend-toggle {\n  background-image: url(\"data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB0PSIxNTk5MDE0Mjk2NTEwIiBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjE3Nzk4IiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0Ij48ZGVmcz48c3R5bGUgdHlwZT0idGV4dC9jc3MiPjwvc3R5bGU+PC9kZWZzPjxwYXRoIGQ9Ik05MzQuNCA0NzguNzJINzM3LjI4Yy0xNS44NzItMTEwLjA4LTExMS4xMDQtMTk0LjU2LTIyNS4yOC0xOTQuNTZTMzAyLjU5MiAzNjguNjQgMjg2LjcyIDQ3OC43Mkg4OS42djY2LjU2SDI4Ni43MmMxNS44NzIgMTEwLjA4IDExMS4xMDQgMTk0LjU2IDIyNS4yOCAxOTQuNTZzMjA5LjQwOC04NC40OCAyMjUuMjgtMTk0LjU2aDE5Ny4xMnYtNjYuNTZ6IiBmaWxsPSIjNzA3MDcwIiBwLWlkPSIxNzc5OSI+PC9wYXRoPjwvc3ZnPg==\");\n  background-repeat: no-repeat;\n  background-position: 50% 50%;\n  box-shadow: none;\n  border-radius: 4px;\n}\n\n.leaflet-legend-contents {\n  display: none;\n}\n\n.leaflet-legend-expanded .leaflet-legend-contents {\n  display: block;\n  padding: 6px 15px 6px 6px;\n}\n\n.leaflet-legend-contents img {\n  position: absolute;\n}\n\n.leaflet-legend-contents:after {\n  content: \"\";\n  display: block;\n  clear: both;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
